<template>
  <div class="pm">
    <PageTabs :tabs="tabs" :initial-tab="activeTab" class="pm-tabs" @select="activeTab = $event" />
    <div class="pm-body">
      <Attribution_Health
        v-if="activeTab === 'attribution'"
        :entity-id="entityId"
      />
      <CostAttributionFlow
        v-if="activeTab === 'cost_flow'"
        :entity-id="entityId"
        :metric-id="metricId"
        :year="year"
        :metric-links="metricLinks"
        :page-type="pageType"
      />
    </div>
  </div>
</template>

<script>
import Attribution_Health from '@/components/Entity/Attribution_Health.vue';
import CostAttributionFlow from '@/components/InsightsNew/CostAttributionFlow.vue';
import PageTabs from '@/components/widgetcomponents/Page_Tabs.vue';

export default {
  name: 'PanelManagementTabs',
  components: { Attribution_Health, CostAttributionFlow, PageTabs },
  props: {
    entityId: { type: Number, default: null },
    metricId: { type: Number, default: null },
    year: { type: Number, default: null },
    metricLinks: { type: Array, default: null },
    pageType: { type: String, default: null },
  },
  data() {
    return {
      activeTab: 'attribution',
      tabs: [
        { id: 'attribution', label: 'Attribution health', description: 'Who stayed, who left and why, between two attribution reports' },
        { id: 'cost_flow', label: 'Cost attribution', description: 'How leavers, stayers and joiners moved cost per person-year' },
      ],
    };
  },
};
</script>

<style scoped>
.pm { margin-top: 8px; }
.pm-tabs { margin-bottom: 16px; }
</style>
